import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AnswerQuestionCommand = {
  chosenOptions?: InputMaybe<Array<ChosenOptionInput>>;
  questionId: Scalars['String']['input'];
  questionnaireSessionId: Scalars['ID']['input'];
};

export type AnsweredQuestion = {
  __typename?: 'AnsweredQuestion';
  chosenOptions?: Maybe<Array<ChosenOption>>;
  question: Question;
  questionnaireSessionId: Scalars['ID']['output'];
};

export type ChangeDiagnosisCommand = {
  diagnosisId: Scalars['String']['input'];
  icdCode: IcdCodeInput;
  justification?: InputMaybe<Scalars['String']['input']>;
};

export type ChosenOption = {
  __typename?: 'ChosenOption';
  chosenOptionId: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ChosenOptionInput = {
  chosenOptionId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Classification = {
  __typename?: 'Classification';
  classification: Scalars['String']['output'];
};

export type ConfirmDiagnosisCommand = {
  diagnosisId: Scalars['String']['input'];
  icdCode: IcdCodeInput;
};

export type CreateConfirmedDiagnosisCommand = {
  icdCode: IcdCodeInput;
  justification?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
};

export type DiagnosedCondition = {
  __typename?: 'DiagnosedCondition';
  classification?: Maybe<Scalars['String']['output']>;
  conditionSet: Scalars['String']['output'];
  icdCode?: Maybe<IcdCode>;
  justification?: Maybe<Justification>;
  subform?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  classifications: Array<Classification>;
  conditions: Array<DiagnosedCondition>;
  diagnosisId: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  questionnaireSessionId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DiagnosisStatus>;
};

export enum DiagnosisStatus {
  Confirmed = 'confirmed',
  Provisional = 'provisional'
}

export type ExternalCode = {
  __typename?: 'ExternalCode';
  framework?: Maybe<Scalars['String']['output']>;
  questionCode?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type FinishQuestionnaireSessionCommand = {
  questionnaireSessionId: Scalars['String']['input'];
};

export enum IcdCategory {
  Ichd_3 = 'ichd_3',
  Nervus = 'nervus'
}

export type IcdCode = {
  __typename?: 'IcdCode';
  category: IcdCategory;
  code?: Maybe<Scalars['String']['output']>;
};

export type IcdCodeInput = {
  category: IcdCategory;
  code?: InputMaybe<Scalars['String']['input']>;
};

/** Common response type for mutations */
export type InputAcceptedResponse = {
  __typename?: 'InputAcceptedResponse';
  /** Identifier for tracking the operation */
  id: Scalars['ID']['output'];
};

export enum InputConstraintType {
  Date = 'date',
  Decimal = 'decimal',
  Email = 'email',
  Number = 'number',
  PhoneNumber = 'phone_number',
  RestrictedValues = 'restricted_values',
  Slider = 'slider',
  Text = 'text'
}

export type InputConstraints = {
  __typename?: 'InputConstraints';
  regex?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  restrictedValues?: Maybe<Array<Scalars['String']['output']>>;
  type: InputConstraintType;
};

export type Justification = {
  __typename?: 'Justification';
  description: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Answer a question in a questionnaire session */
  answerQuestion: InputAcceptedResponse;
  /** Change an existing diagnosis */
  changeDiagnosis: InputAcceptedResponse;
  /** Confirm a provisional diagnosis */
  confirmDiagnosis: InputAcceptedResponse;
  /** Create a confirmed diagnosis */
  createConfirmedDiagnosis: InputAcceptedResponse;
  /** Complete a questionnaire session */
  finishQuestionnaireSession: InputAcceptedResponse;
  /** Register a user login event with timezone */
  registerLogin?: Maybe<InputAcceptedResponse>;
  /** Revise a previously given answer */
  reviseAnswer: InputAcceptedResponse;
  /** Start a new questionnaire session */
  startQuestionnaireSession: InputAcceptedResponse;
};


export type MutationAnswerQuestionArgs = {
  input: AnswerQuestionCommand;
};


export type MutationChangeDiagnosisArgs = {
  input: ChangeDiagnosisCommand;
};


export type MutationConfirmDiagnosisArgs = {
  input: ConfirmDiagnosisCommand;
};


export type MutationCreateConfirmedDiagnosisArgs = {
  input: CreateConfirmedDiagnosisCommand;
};


export type MutationFinishQuestionnaireSessionArgs = {
  input: FinishQuestionnaireSessionCommand;
};


export type MutationRegisterLoginArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationReviseAnswerArgs = {
  input: ReviseAnswerCommand;
};


export type MutationStartQuestionnaireSessionArgs = {
  input: StartQuestionnaireSessionCommand;
};

export type Option = {
  __typename?: 'Option';
  definitions?: Maybe<Array<TermDefinition>>;
  description?: Maybe<Scalars['String']['output']>;
  inputConstraints?: Maybe<InputConstraints>;
  label: Scalars['String']['output'];
  noneOfTheAbove?: Maybe<Scalars['Boolean']['output']>;
  optionId: Scalars['ID']['output'];
  subOptions?: Maybe<Array<Option>>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Patient = {
  __typename?: 'Patient';
  timezone?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Base schema defining core types and interfaces */
export type Query = {
  __typename?: 'Query';
  /** Get diagnosis for a completed questionnaire session */
  diagnosis: Diagnosis;
  /** Get the currently authenticated user */
  me: User;
  /** Get the next question in a questionnaire session */
  nextQuestion?: Maybe<Question>;
  /** Get a specific questionnaire by ID */
  questionnaire: Questionnaire;
  /** Get a specific questionnaire session */
  questionnaireSession?: Maybe<QuestionnaireSession>;
  /** Get a questionnaire session by patient ID */
  questionnaireSessionByPatient?: Maybe<QuestionnaireSession>;
  /** Get a questionnaire session by questionnaire ID */
  questionnaireSessionByQuestionnaire?: Maybe<QuestionnaireSession>;
  /** List all available questionnaires */
  questionnaires: Array<Questionnaire>;
};


/** Base schema defining core types and interfaces */
export type QueryDiagnosisArgs = {
  questionnaireSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryNextQuestionArgs = {
  activeQuestionId?: InputMaybe<Scalars['String']['input']>;
  questionnaireSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryQuestionnaireArgs = {
  questionnaireId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryQuestionnaireSessionArgs = {
  questionnaireSessionId: Scalars['ID']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryQuestionnaireSessionByPatientArgs = {
  patientId: Scalars['ID']['input'];
  questionnaireId: Scalars['String']['input'];
};


/** Base schema defining core types and interfaces */
export type QueryQuestionnaireSessionByQuestionnaireArgs = {
  questionnaireId: Scalars['ID']['input'];
};

export type Question = {
  __typename?: 'Question';
  description?: Maybe<Scalars['String']['output']>;
  externalCode?: Maybe<ExternalCode>;
  label: Scalars['String']['output'];
  options?: Maybe<Array<Option>>;
  questionId: Scalars['ID']['output'];
  type: QuestionType;
};

export enum QuestionType {
  BodyLocator = 'body_locator',
  Breather = 'breather',
  LikertScale = 'likert_scale',
  ManualInput = 'manual_input',
  MeasurementInput = 'measurement_input',
  MultipleChoice = 'multiple_choice',
  PainSlider = 'pain_slider',
  SingleChoice = 'single_choice',
  Slider = 'slider'
}

export type Questionnaire = {
  __typename?: 'Questionnaire';
  name: Scalars['String']['output'];
  questionnaireId: Scalars['ID']['output'];
};

export type QuestionnaireSession = {
  __typename?: 'QuestionnaireSession';
  activeQuestionId?: Maybe<Scalars['String']['output']>;
  answeredQuestions?: Maybe<Array<AnsweredQuestion>>;
  finished: Scalars['Boolean']['output'];
  questionnaireId: Scalars['String']['output'];
  questionnaireSessionId: Scalars['ID']['output'];
};

export type ReviseAnswerCommand = {
  chosenOptions?: InputMaybe<Array<ChosenOptionInput>>;
  questionId: Scalars['String']['input'];
  questionnaireSessionId: Scalars['ID']['input'];
};

export type StartQuestionnaireSessionCommand = {
  /** Each questionnaire has a hardcoded ID on the platform (e.g. "qstnre_primary_headache") */
  questionnaireId: Scalars['String']['input'];
  questionnaireSessionId: Scalars['String']['input'];
};

export type TermDefinition = {
  __typename?: 'TermDefinition';
  definition: Scalars['String']['output'];
  term: Scalars['String']['output'];
};

export type User = Patient;

export type GetQuestionnairesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionnairesQuery = { __typename?: 'Query', questionnaires: Array<{ __typename?: 'Questionnaire', questionnaireId: string, name: string }> };

export type StartQuestionnaireMutationVariables = Exact<{
  input: StartQuestionnaireSessionCommand;
}>;


export type StartQuestionnaireMutation = { __typename?: 'Mutation', startQuestionnaireSession: { __typename?: 'InputAcceptedResponse', id: string } };

export type GetQuestionnaireSessionQueryVariables = Exact<{
  questionnaireSessionId: Scalars['ID']['input'];
}>;


export type GetQuestionnaireSessionQuery = { __typename?: 'Query', questionnaireSession?: { __typename?: 'QuestionnaireSession', questionnaireSessionId: string, questionnaireId: string, activeQuestionId?: string | null, finished: boolean, answeredQuestions?: Array<{ __typename?: 'AnsweredQuestion', questionnaireSessionId: string, question: { __typename?: 'Question', questionId: string, type: QuestionType, label: string, description?: string | null, options?: Array<{ __typename?: 'Option', optionId: string, label: string, value?: string | null, unit?: string | null, description?: string | null, noneOfTheAbove?: boolean | null, inputConstraints?: { __typename?: 'InputConstraints', type: InputConstraintType, required: boolean, regex?: string | null, restrictedValues?: Array<string> | null } | null, definitions?: Array<{ __typename?: 'TermDefinition', term: string, definition: string }> | null, subOptions?: Array<{ __typename?: 'Option', optionId: string, label: string, value?: string | null, unit?: string | null, description?: string | null, noneOfTheAbove?: boolean | null }> | null }> | null }, chosenOptions?: Array<{ __typename?: 'ChosenOption', chosenOptionId: string, value?: string | null }> | null }> | null } | null };

export type GetNextQuestionQueryVariables = Exact<{
  questionnaireSessionId: Scalars['ID']['input'];
  activeQuestionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNextQuestionQuery = { __typename?: 'Query', nextQuestion?: { __typename?: 'Question', questionId: string, type: QuestionType, label: string, description?: string | null, externalCode?: { __typename?: 'ExternalCode', framework?: string | null, questionCode?: string | null, version?: string | null } | null, options?: Array<{ __typename?: 'Option', optionId: string, label: string, value?: string | null, unit?: string | null, description?: string | null, noneOfTheAbove?: boolean | null, inputConstraints?: { __typename?: 'InputConstraints', type: InputConstraintType, required: boolean, regex?: string | null, restrictedValues?: Array<string> | null } | null, definitions?: Array<{ __typename?: 'TermDefinition', term: string, definition: string }> | null, subOptions?: Array<{ __typename?: 'Option', optionId: string, label: string, value?: string | null, unit?: string | null, description?: string | null, noneOfTheAbove?: boolean | null }> | null }> | null } | null };

export type AnswerQuestionMutationVariables = Exact<{
  input: AnswerQuestionCommand;
}>;


export type AnswerQuestionMutation = { __typename?: 'Mutation', answerQuestion: { __typename?: 'InputAcceptedResponse', id: string } };

export type FinishQuestionnaireSessionMutationVariables = Exact<{
  input: FinishQuestionnaireSessionCommand;
}>;


export type FinishQuestionnaireSessionMutation = { __typename?: 'Mutation', finishQuestionnaireSession: { __typename?: 'InputAcceptedResponse', id: string } };

export type GetDiagnosisQueryVariables = Exact<{
  questionnaireSessionId: Scalars['ID']['input'];
}>;


export type GetDiagnosisQuery = { __typename?: 'Query', diagnosis: { __typename?: 'Diagnosis', diagnosisId: string, status?: DiagnosisStatus | null, conditions: Array<{ __typename?: 'DiagnosedCondition', conditionSet: string, classification?: string | null, type?: string | null, subtype?: string | null, subform?: string | null, icdCode?: { __typename?: 'IcdCode', category: IcdCategory, code?: string | null } | null, justification?: { __typename?: 'Justification', description: string } | null }>, classifications: Array<{ __typename?: 'Classification', classification: string }> } };

export type RegisterLoginMutationVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type RegisterLoginMutation = { __typename?: 'Mutation', registerLogin?: { __typename?: 'InputAcceptedResponse', id: string } | null };


export const GetQuestionnairesDocument = gql`
    query GetQuestionnaires {
  questionnaires {
    questionnaireId
    name
  }
}
    `;

/**
 * __useGetQuestionnairesQuery__
 *
 * To run a query within a React component, call `useGetQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnairesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnairesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionnairesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>(GetQuestionnairesDocument, options);
      }
export function useGetQuestionnairesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>(GetQuestionnairesDocument, options);
        }
export function useGetQuestionnairesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>(GetQuestionnairesDocument, options);
        }
export type GetQuestionnairesQueryHookResult = ReturnType<typeof useGetQuestionnairesQuery>;
export type GetQuestionnairesLazyQueryHookResult = ReturnType<typeof useGetQuestionnairesLazyQuery>;
export type GetQuestionnairesSuspenseQueryHookResult = ReturnType<typeof useGetQuestionnairesSuspenseQuery>;
export type GetQuestionnairesQueryResult = Apollo.QueryResult<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>;
export const StartQuestionnaireDocument = gql`
    mutation StartQuestionnaire($input: StartQuestionnaireSessionCommand!) {
  startQuestionnaireSession(input: $input) {
    id
  }
}
    `;
export type StartQuestionnaireMutationFn = Apollo.MutationFunction<StartQuestionnaireMutation, StartQuestionnaireMutationVariables>;

/**
 * __useStartQuestionnaireMutation__
 *
 * To run a mutation, you first call `useStartQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuestionnaireMutation, { data, loading, error }] = useStartQuestionnaireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<StartQuestionnaireMutation, StartQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartQuestionnaireMutation, StartQuestionnaireMutationVariables>(StartQuestionnaireDocument, options);
      }
export type StartQuestionnaireMutationHookResult = ReturnType<typeof useStartQuestionnaireMutation>;
export type StartQuestionnaireMutationResult = Apollo.MutationResult<StartQuestionnaireMutation>;
export type StartQuestionnaireMutationOptions = Apollo.BaseMutationOptions<StartQuestionnaireMutation, StartQuestionnaireMutationVariables>;
export const GetQuestionnaireSessionDocument = gql`
    query GetQuestionnaireSession($questionnaireSessionId: ID!) {
  questionnaireSession(questionnaireSessionId: $questionnaireSessionId) {
    questionnaireSessionId
    questionnaireId
    activeQuestionId
    finished
    answeredQuestions {
      questionnaireSessionId
      question {
        questionId
        type
        label
        description
        options {
          optionId
          label
          value
          unit
          description
          noneOfTheAbove
          inputConstraints {
            type
            required
            regex
            restrictedValues
          }
          definitions {
            term
            definition
          }
          subOptions {
            optionId
            label
            value
            unit
            description
            noneOfTheAbove
          }
        }
      }
      chosenOptions {
        chosenOptionId
        value
      }
    }
  }
}
    `;

/**
 * __useGetQuestionnaireSessionQuery__
 *
 * To run a query within a React component, call `useGetQuestionnaireSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionnaireSessionQuery({
 *   variables: {
 *      questionnaireSessionId: // value for 'questionnaireSessionId'
 *   },
 * });
 */
export function useGetQuestionnaireSessionQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables> & ({ variables: GetQuestionnaireSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables>(GetQuestionnaireSessionDocument, options);
      }
export function useGetQuestionnaireSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables>(GetQuestionnaireSessionDocument, options);
        }
export function useGetQuestionnaireSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables>(GetQuestionnaireSessionDocument, options);
        }
export type GetQuestionnaireSessionQueryHookResult = ReturnType<typeof useGetQuestionnaireSessionQuery>;
export type GetQuestionnaireSessionLazyQueryHookResult = ReturnType<typeof useGetQuestionnaireSessionLazyQuery>;
export type GetQuestionnaireSessionSuspenseQueryHookResult = ReturnType<typeof useGetQuestionnaireSessionSuspenseQuery>;
export type GetQuestionnaireSessionQueryResult = Apollo.QueryResult<GetQuestionnaireSessionQuery, GetQuestionnaireSessionQueryVariables>;
export const GetNextQuestionDocument = gql`
    query GetNextQuestion($questionnaireSessionId: ID!, $activeQuestionId: String) {
  nextQuestion(
    questionnaireSessionId: $questionnaireSessionId
    activeQuestionId: $activeQuestionId
  ) {
    questionId
    type
    label
    description
    externalCode {
      framework
      questionCode
      version
    }
    options {
      optionId
      label
      value
      unit
      description
      noneOfTheAbove
      inputConstraints {
        type
        required
        regex
        restrictedValues
      }
      definitions {
        term
        definition
      }
      subOptions {
        optionId
        label
        value
        unit
        description
        noneOfTheAbove
      }
    }
  }
}
    `;

/**
 * __useGetNextQuestionQuery__
 *
 * To run a query within a React component, call `useGetNextQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextQuestionQuery({
 *   variables: {
 *      questionnaireSessionId: // value for 'questionnaireSessionId'
 *      activeQuestionId: // value for 'activeQuestionId'
 *   },
 * });
 */
export function useGetNextQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetNextQuestionQuery, GetNextQuestionQueryVariables> & ({ variables: GetNextQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextQuestionQuery, GetNextQuestionQueryVariables>(GetNextQuestionDocument, options);
      }
export function useGetNextQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextQuestionQuery, GetNextQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextQuestionQuery, GetNextQuestionQueryVariables>(GetNextQuestionDocument, options);
        }
export function useGetNextQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNextQuestionQuery, GetNextQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNextQuestionQuery, GetNextQuestionQueryVariables>(GetNextQuestionDocument, options);
        }
export type GetNextQuestionQueryHookResult = ReturnType<typeof useGetNextQuestionQuery>;
export type GetNextQuestionLazyQueryHookResult = ReturnType<typeof useGetNextQuestionLazyQuery>;
export type GetNextQuestionSuspenseQueryHookResult = ReturnType<typeof useGetNextQuestionSuspenseQuery>;
export type GetNextQuestionQueryResult = Apollo.QueryResult<GetNextQuestionQuery, GetNextQuestionQueryVariables>;
export const AnswerQuestionDocument = gql`
    mutation AnswerQuestion($input: AnswerQuestionCommand!) {
  answerQuestion(input: $input) {
    id
  }
}
    `;
export type AnswerQuestionMutationFn = Apollo.MutationFunction<AnswerQuestionMutation, AnswerQuestionMutationVariables>;

/**
 * __useAnswerQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionMutation, { data, loading, error }] = useAnswerQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerQuestionMutation, AnswerQuestionMutationVariables>(AnswerQuestionDocument, options);
      }
export type AnswerQuestionMutationHookResult = ReturnType<typeof useAnswerQuestionMutation>;
export type AnswerQuestionMutationResult = Apollo.MutationResult<AnswerQuestionMutation>;
export type AnswerQuestionMutationOptions = Apollo.BaseMutationOptions<AnswerQuestionMutation, AnswerQuestionMutationVariables>;
export const FinishQuestionnaireSessionDocument = gql`
    mutation FinishQuestionnaireSession($input: FinishQuestionnaireSessionCommand!) {
  finishQuestionnaireSession(input: $input) {
    id
  }
}
    `;
export type FinishQuestionnaireSessionMutationFn = Apollo.MutationFunction<FinishQuestionnaireSessionMutation, FinishQuestionnaireSessionMutationVariables>;

/**
 * __useFinishQuestionnaireSessionMutation__
 *
 * To run a mutation, you first call `useFinishQuestionnaireSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishQuestionnaireSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishQuestionnaireSessionMutation, { data, loading, error }] = useFinishQuestionnaireSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishQuestionnaireSessionMutation(baseOptions?: Apollo.MutationHookOptions<FinishQuestionnaireSessionMutation, FinishQuestionnaireSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishQuestionnaireSessionMutation, FinishQuestionnaireSessionMutationVariables>(FinishQuestionnaireSessionDocument, options);
      }
export type FinishQuestionnaireSessionMutationHookResult = ReturnType<typeof useFinishQuestionnaireSessionMutation>;
export type FinishQuestionnaireSessionMutationResult = Apollo.MutationResult<FinishQuestionnaireSessionMutation>;
export type FinishQuestionnaireSessionMutationOptions = Apollo.BaseMutationOptions<FinishQuestionnaireSessionMutation, FinishQuestionnaireSessionMutationVariables>;
export const GetDiagnosisDocument = gql`
    query GetDiagnosis($questionnaireSessionId: ID!) {
  diagnosis(questionnaireSessionId: $questionnaireSessionId) {
    diagnosisId
    conditions {
      icdCode {
        category
        code
      }
      conditionSet
      classification
      type
      subtype
      subform
      justification {
        description
      }
    }
    classifications {
      classification
    }
    status
  }
}
    `;

/**
 * __useGetDiagnosisQuery__
 *
 * To run a query within a React component, call `useGetDiagnosisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosisQuery({
 *   variables: {
 *      questionnaireSessionId: // value for 'questionnaireSessionId'
 *   },
 * });
 */
export function useGetDiagnosisQuery(baseOptions: Apollo.QueryHookOptions<GetDiagnosisQuery, GetDiagnosisQueryVariables> & ({ variables: GetDiagnosisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiagnosisQuery, GetDiagnosisQueryVariables>(GetDiagnosisDocument, options);
      }
export function useGetDiagnosisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiagnosisQuery, GetDiagnosisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiagnosisQuery, GetDiagnosisQueryVariables>(GetDiagnosisDocument, options);
        }
export function useGetDiagnosisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDiagnosisQuery, GetDiagnosisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDiagnosisQuery, GetDiagnosisQueryVariables>(GetDiagnosisDocument, options);
        }
export type GetDiagnosisQueryHookResult = ReturnType<typeof useGetDiagnosisQuery>;
export type GetDiagnosisLazyQueryHookResult = ReturnType<typeof useGetDiagnosisLazyQuery>;
export type GetDiagnosisSuspenseQueryHookResult = ReturnType<typeof useGetDiagnosisSuspenseQuery>;
export type GetDiagnosisQueryResult = Apollo.QueryResult<GetDiagnosisQuery, GetDiagnosisQueryVariables>;
export const RegisterLoginDocument = gql`
    mutation RegisterLogin($timezone: String!) {
  registerLogin(timezone: $timezone) {
    id
  }
}
    `;
export type RegisterLoginMutationFn = Apollo.MutationFunction<RegisterLoginMutation, RegisterLoginMutationVariables>;

/**
 * __useRegisterLoginMutation__
 *
 * To run a mutation, you first call `useRegisterLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLoginMutation, { data, loading, error }] = useRegisterLoginMutation({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useRegisterLoginMutation(baseOptions?: Apollo.MutationHookOptions<RegisterLoginMutation, RegisterLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterLoginMutation, RegisterLoginMutationVariables>(RegisterLoginDocument, options);
      }
export type RegisterLoginMutationHookResult = ReturnType<typeof useRegisterLoginMutation>;
export type RegisterLoginMutationResult = Apollo.MutationResult<RegisterLoginMutation>;
export type RegisterLoginMutationOptions = Apollo.BaseMutationOptions<RegisterLoginMutation, RegisterLoginMutationVariables>;